import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SzerkZarService } from './szerk-zar.service';

/**
 *  A lap szerkesztési zárjai (szerk-zar.service.ts) minden MÓDOSÍTÓ /api kérés fejlécébe (X-Szerk-Zar):
 *  a kiszolgáló ebből tudja, hogy a mentő a rekord zárjának birtokosa-e (backend/szerkesztes-zar.js vedo).
 *  Olvasó kéréshez nem kell, és ha a lapnak nincs zárja, a fejléc sem megy.
 */
@Injectable()
export class SzerkZarInterceptor implements HttpInterceptor {
  /*  Lustán: a szolgáltatás maga is HttpClientet kér, amely az interceptorokra épül – a konstruktorban
   *  kérve körkörös függés lenne. */
  private zarak: SzerkZarService | null = null;
  constructor(private injector: Injector) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.method === 'GET' || req.method === 'HEAD' || req.method === 'OPTIONS') return next.handle(req);
    //  Csak a saját, relatív /api hívásokra (az ApiPrefix utánunk írja abszolúttá) – idegen címre a token nem megy.
    if (!(req.url.startsWith('/api/') || req.url.startsWith('api/'))) return next.handle(req);
    if (!this.zarak) this.zarak = this.injector.get(SzerkZarService);
    const ertek = this.zarak.fejlec();
    return next.handle(ertek ? req.clone({ setHeaders: { 'X-Szerk-Zar': ertek } }) : req);
  }
}
